import React from 'react';
export function SystemPreview() {
  return <section className="w-full bg-white px-4 md:px-8 py-16" data-id="element-329">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-330">
        {/* Title */}
        <h2 className="font-['Playfair_Display',_serif] text-2xl md:text-3xl lg:text-[36px] font-bold text-[#1a1a1a] leading-tight mb-3" data-id="element-331">
          👀 Mirá el Sistema por Dentro
        </h2>
        <div className="w-16 h-1 bg-[#4caf50] mx-auto mb-6" data-id="element-332"></div>

        {/* Subtitle */}
        <p className="font-['Montserrat',_sans-serif] text-[#555] text-base md:text-lg mb-10" data-id="element-333">
          Nada de PDFs aburridos. Material interactivo, planillas automáticas y
          diseño premium.
        </p>

        {/* Video inside card with shadow */}
        <div className="flex justify-center" data-id="element-334">
          <div className="bg-white rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.12)] p-4 md:p-6 w-full max-w-[500px]" data-id="element-335">
            <div className="w-full aspect-[9/16] rounded-xl overflow-hidden bg-[#222] relative" data-id="element-336">
              <iframe src="https://www.loom.com/embed/ef64db019ff242fb93b6ac4c2c7159d0?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true" frameBorder="0" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-337" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}